export default function({ redirect, route }) {
  if (route.path[route.path.length - 1] === '/' && route.path.length > 1) {
    return redirect(301, route.path.slice(0, -1))
  }
}
